import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type TState = {
  invoiceNumber: string | null;
};

type TAction = {
  setInvoiceNumber: (invoiceNumber: string) => void;
  resetState: () => void;
};

export const useChatStore = create<TState & TAction>()(
  immer((set) => ({
    invoiceNumber: null,
    setInvoiceNumber: (invoiceNumber) => {
      set((state) => {
        state.invoiceNumber = invoiceNumber;
      });
    },
    resetState: () => {
      set((state) => {
        state.invoiceNumber = null;
      });
    },
  }))
);
